import React, { useContext, useEffect, useState } from "react";
import HeadingBanner from "../Components/HeadingBanner.jsx";
import Dashboard from "../Components/Dashboard.jsx";
import { useLocation, useNavigate } from "react-router-dom";
import { Logindetail } from "../context/Logindetail.js";
import instance from "../Config/Config.js";
import { getProductStockApi } from "../api/Dashboardapi.js";

const Myorder = ({ settings }) => {
  const [orderid2, setOrderId2] = useState([]);
  const [productListData, setProductListData] = useState([]);
  const [Agentorderlist, setAgentorderlist] = useState([]);

  const [isloading, setIsloading] = useState(true);
  const GetCheckoutList = async () => {
    setIsloading(true); // ✅ Start loading
    try {
      const responseApi = await instance.get(`my_order_list`);
      // console.log("responseApi", responseApi);
      setOrderId2(responseApi?.data?.order);
      setIsloading(false);
    } catch (error) {
      console.error(
        "Error fetching cart:",
        error.response?.data || error.message
      );
      setIsloading(true);
    }
  };

  const location = useLocation();
  const type = location?.state?.type;

  const GetCheckoutList2 = async () => {
    setIsloading(true); // ✅ Start loading
    try {
      const responseApi = await instance.get(`agent_order_list`);

      // console.log("setAgentorderlist", responseApi?.data?.data);
      setAgentorderlist(responseApi?.data?.data);
      setIsloading(false);
    } catch (error) {
      console.error(
        "Error fetching cart:",
        error.response?.data || error.message
      );
      setIsloading(true);
    }
  };

  const GetCheckoutList3 = async () => {
    setIsloading(true);
    try {
      const responseApi = await instance.get(`agent_product_list`);
      // console.log("responseApidataproduct", responseApi?.data?.data);
      setProductListData(responseApi?.data?.data);
      setIsloading(false);
    } catch (error) {
      console.error(
        "Error fetching cart:",
        error.response?.data || error.message
      );
      setIsloading(true);
    }
  };

  useEffect(() => {
    if (type === "Company") {
      GetCheckoutList2();
    } else if (type === "Products") {
      GetCheckoutList3();
    } else {
      // For any other type (or if type is undefined/null)
      GetCheckoutList();
    }
  }, [type]);

  const orderid = [
    {
      orderid: "00121",
      weight: "8.354 g",
      total: "4,800",
      purchasedate: "22-05-24",
      status: "pending",
      id: 1,
      name: "Gh 1 Gram Gold ",
      price: "₹ 50000.32",
      image: "https://admin.greenheapgold.com/public/product/1726897514_1.png",
      pdf: "",
    },
    {
      orderid: "00122",
      weight: "20.35 g",
      total: "8000",
      purchasedate: "21-05-24",
      status: "purchased",
      id: 2,
      name: "22 gram girls silver",
      price: "₹ 500.36",
      image: "https://admin.greenheapgold.com/public/product/1726897539_6.png",
      pdf: "",
    },
    {
      orderid: "00123",
      weight: "9.954 g",
      total: "58,093",
      purchasedate: "26-04-24",
      status: "Cancelled",
      id: 3,
      name: "Gh 1 Gram Coin 24k ",
      price: "₹ 6543121.00",
      image: "https://admin.greenheapgold.com/public/product/1726922591_5.png",
    },

    {
      orderid: "00124",
      weight: "48.54 g",
      total: "54,980",
      purchasedate: "11-03-24",
      status: "pending",
      id: 3,
      name: "Gh 1 Gram Coin 24k ",
      price: "₹ 6543121.00",
      image: "https://admin.greenheapgold.com/public/product/1726922591_5.png",
    },
  ];

  const navigate = useNavigate();

  const { token, detail_info } = useContext(Logindetail);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const [showStockModal, setShowStockModal] = useState(false);
  const [stockData, setStockData] = useState(null);
  const [selectedProductForStock, setSelectedProductForStock] = useState(null);
  const [stockLoading, setStockLoading] = useState(false);

  const fetchProductStock = async (id, page = 1) => {
    setStockLoading(true);
    try {
      const response = await getProductStockApi(id, page);
      if (response && response.status) {
        setStockData(response);
      }
    } catch (error) {
      console.error("Error fetching product stock:", error);
    } finally {
      setStockLoading(false);
    }
  };

  const handleOpenStockModal = (product) => {
    setSelectedProductForStock(product);
    setShowStockModal(true);
    fetchProductStock(product.id, 1);
  };

  const check = token;

  // useEffect(()=>{
  //     //  if(!check ){
  //     //    navigate('/')
  //     //  }
  // },[])

  const [showCancelModal, setShowCancelModal] = React.useState(false);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = String(date.getFullYear()).slice(-2); // last 2 digits of year
    return `${day}-${month}-${year}`;
  };

  const handleInvoiceDownload = async (orderId) => {
    try {
      const response = await instance.get(
        `digital_invoice_download_order/${orderId}`,
        {
          responseType: "blob",
        }
      );

      const contentDisposition = response.headers["content-disposition"];
      const fileName = contentDisposition
        ? contentDisposition.split("filename=")[1]?.replace(/"/g, "")
        : `invoice-${orderId}.pdf`;

      // Trigger file download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Invoice download failed:", error);
      alert("Failed to download invoice. Please try again.");
    }
  };

  useEffect(() => {
    setFilteredOrders(orderid2 || []);
  }, [orderid2]);

  const [searchText, setSearchText] = useState("");
  const [filteredOrders, setFilteredOrders] = useState(orderid2 || []);
  const [rowsToShow, setRowsToShow] = useState(11);

  // const handleInputChange = (e) => {
  //   const text = e.target.value;
  //   setSearchText(text);

  //   const filtered = orderid2.filter((order) => {
  //     return (
  //       order.code?.toLowerCase().includes(text.toLowerCase()) ||
  //       order?.delivery_status?.toLowerCase().includes(text.toLowerCase()) ||
  //       order?.status?.toLowerCase().includes(text.toLowerCase()) ||
  //       formatDate(order?.created_at)?.toLowerCase().includes(text.toLowerCase())
  //     );
  //   });

  //   setFilteredOrders(filtered);
  // };

  const handleInputChange = (e) => {
    const text = e.target.value;
    setSearchText(text);

    const filtered = orderid2.filter((order) => {
      const createdAt = new Date(order.created_at).toLocaleDateString();
      const deliveredDate = order.delivered_date
        ? formatDate(order.delivered_date).toLowerCase()
        : "";

      return (
        order.code?.toLowerCase().includes(text.toLowerCase()) ||
        order.delivery_status?.toLowerCase().includes(text.toLowerCase()) ||
        createdAt.toLowerCase().includes(text.toLowerCase()) ||
        deliveredDate.toLowerCase().includes(text.toLowerCase()) ||
        order.grand_total?.toString().includes(text)
      );
    });

    setFilteredOrders(filtered);
  };

  const handleRowsToShowChange = (e) => {
    setRowsToShow(parseInt(e.target.value, 10));
  };

  return (
    <>
      <HeadingBanner title={"My Orders"} />
      <section>
        <div className="container">
          <div className="siptrans-layout">
            <div className="row">
              <div className="col-xl-3 col-lg-4">
                <Dashboard setting_data={settings} />
              </div>

              {type !== "Company" && type !== "Products" && (
                <div className="col-xl-9 col-lg-8">
                  <div className="siptrans-content">
                    <div className="siptrans-head pb-3">
                      <h4>My Orders</h4>
                    </div>
                    <div
                      className="siptrans-table border pt-2 "
                      style={{ overflow: "auto" }}
                    >
                      <div className="sipshow-search d-flex align-items-center  justify-content-between gap-sm-0 gap-3">
                        <div className="sipshow d-flex align-items-center gap-sm-3 gap-2 mb-3">
                          <h4 className="m-0">Show</h4>
                          <select
                            className="form-select"
                            id="inputGroupSelectshow"
                            value={rowsToShow}
                            onChange={handleRowsToShowChange}
                            style={{ width: "80px" }}
                          >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value={0}>All</option>
                          </select>
                        </div>
                        <div className="sip-search position-relative">
                          <input
                            type="text"
                            className="form-control"
                            id="inputemail"
                            placeholder="Search"
                            value={searchText}
                            onChange={handleInputChange}
                          />
                          {searchText.trim() === "" && (
                            <img
                              src="\assets\iocns\Search.png"
                              className="img-fluid"
                            />
                          )}
                        </div>
                      </div>
                      <div className="siptable-view">
                        <table className="table">
                          <thead>
                            <tr className="text-center">
                              <th scope="col">Order id</th>
                              <th scope="col">Total</th>
                              <th scope="col">Purchase Date</th>
                              <th scope="col">Status</th>
                              <th scope="col">View</th>
                              <th scope="col">Invoice</th>
                            </tr>
                          </thead>

                          <tbody>
                            {isloading ? (
                              <tr>
                                <td colSpan="6" className="text-center py-4">
                                  <div className="tableload tableload2 commision-load text-center mt-5">
                                    <div
                                      className="spinner-border text-primary text-center"
                                      role="status"
                                    ></div>
                                  </div>
                                </td>
                              </tr>
                            ) : filteredOrders?.length === 0 ? (
                              <tr>
                                <td colSpan="6" className="text-center py-4">
                                  No orders available.
                                </td>
                              </tr>
                            ) : (
                              (rowsToShow === 0
                                ? filteredOrders
                                : filteredOrders.slice(0, rowsToShow)
                              ).map((r, i) => (
                                <tr className="text-center" key={i}>
                                  <td>{r.code}</td>
                                  <td>
                                    {/* {r?.grand_total ? r?.grand_total : "-"} */}
                                    {r?.payment_type === "wallet" ? (
                                      <span>Wallet Used</span>
                                    ) : r?.grand_total != null ? (
                                      `₹ ${Number(r.grand_total).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}`
                                    ) : (
                                      "-"
                                    )}

                                    {/* {r?.grand_total != null
                                      ? `₹ ${Number(r.grand_total).toLocaleString('en-IN', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}`
                                      : "-"
                                    } */}

                                  </td>
                                  <td>{formatDate(r.created_at)}</td>
                                  <td
                                    style={{
                                      color:
                                        // r.delivery_status === "pending"
                                        //   ? "blue"
                                        //   : r.status === "delivered"
                                        //   ? "green"
                                        //   :r.status === "purchased"? "black"
                                        //   : "red",
                                        r.delivery_status === "pending"
                                          ? "blue"
                                          : r.delivery_status === "delivered" || r.delivery_status === "confirmed"
                                            ? "green"
                                            : r.delivery_status === "cancelled"
                                              ? "red"
                                              : "black",
                                    }}
                                  >
                                    {/* {r?.delivery_status} */}
                                    {r?.delivery_status
                                      ? r.delivery_status
                                        .split('_')
                                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                        .join(' ')
                                      : ""}

                                    {/* {r?.delivery_status
  ? r.delivery_status.charAt(0).toUpperCase() + r.delivery_status.slice(1)
  : ""} */}
                                  </td>
                                  <td
                                    className="text-center"
                                    onClick={() => {
                                      navigate(`/orderdetails/${r.id}`, {
                                        state: { orderData: r },
                                      });
                                    }}
                                  >
                                    <img
                                      src="/assets/iocns/eye.png"
                                      className="img-fluid"
                                      alt="View"
                                    />
                                  </td>
                                  <td
                                    className="text-center"
                                    onClick={() => handleInvoiceDownload(r.id)}
                                  >
                                    <img
                                      src="/assets/iocns/invoice.png"
                                      className="img-fluid"
                                      alt="Invoice"
                                    />
                                  </td>

                                  {/* Hidden Modal Section */}
                                  <td colSpan={6} className="p-0 border-0">
                                    <section className="odersection">
                                      <button
                                        type="button"
                                        className="btn btn-primary d-none"
                                        data-bs-toggle="modal"
                                        data-bs-target="#paymentbox"
                                        id="payment-pup"
                                      >
                                        Launch demo modal
                                      </button>

                                      <div
                                        className="modal fade"
                                        id="paymentbox"
                                        tabIndex="-1"
                                        role="dialog"
                                        aria-labelledby="exampleModalCenterTitle"
                                        aria-hidden="true"
                                      >
                                        <div className="modal-dialog modal-dialog-centered">
                                          <div className="modal-content">
                                            <div className="modal-header d-flex justify-content-between">
                                              <div className="colhome2">
                                                <b>
                                                  Order Id :{" "}
                                                  {selectedOrder?.orderid}
                                                </b>
                                              </div>
                                              <div className="d-flex">
                                                <div
                                                  className="buttondesign2 marginleft align-items-center"
                                                  style={{ cursor: "pointer" }}
                                                  onClick={() =>
                                                    setShowCancelModal(true)
                                                  }
                                                >
                                                  <b>Order Cancel</b>
                                                </div>
                                                <button
                                                  type="button"
                                                  className="btn-close"
                                                  data-bs-dismiss="modal"
                                                  aria-label="Close"
                                                ></button>
                                              </div>
                                            </div>
                                            <div className="modal-body">
                                              {selectedOrder && (
                                                <div className="d-flex gap-3">
                                                  <img
                                                    src={selectedOrder?.image}
                                                    alt={selectedOrder?.name}
                                                    className="img-fluid forthis"
                                                  />
                                                  <div>
                                                    <h6 className="fw-bold">
                                                      {selectedOrder?.name}
                                                    </h6>
                                                    <p className="text-muted">
                                                      {selectedOrder?.price}
                                                    </p>
                                                    <p
                                                      className="text-capitalize"
                                                      style={{
                                                        color:
                                                          selectedOrder?.status ===
                                                            "pending"
                                                            ? "orange"
                                                            : selectedOrder.status ===
                                                              "purchased"
                                                              ? "green"
                                                              : "red",
                                                      }}
                                                    >
                                                      Status:{" "}
                                                      {selectedOrder?.status}
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </section>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {type === "Company" && Number(detail_info?.company) === 1 && (
                <div className="col-xl-9 col-lg-8">
                  <div className="siptrans-content">
                    <div className="siptrans-head pb-3">
                      <h4>Order List</h4>
                    </div>
                    <div
                      className="siptrans-table border pt-2 "
                      style={{ overflow: "auto" }}
                    >
                      {/* <div className="sipshow-search d-flex align-items-center  justify-content-between gap-sm-0 gap-3">
                        <div className="sipshow d-flex align-items-center gap-sm-3 gap-2 mb-3">
                          <h4 className="m-0">Show</h4>
                          <select
                            className="form-select"
                            id="inputGroupSelectshow"
                            value={rowsToShow}
                            onChange={handleRowsToShowChange}
                            style={{ width: "80px" }}
                          >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value={0}>All</option>
                          </select>
                        </div>
                        <div className="sip-search position-relative">
                          <input
                            type="text"
                            className="form-control"
                            id="inputemail"
                            placeholder="Search"
                            value={searchText}
                            onChange={handleInputChange}
                          />
                          {searchText.trim() === "" && (
                            <img
                              src="\assets\iocns\Search.png"
                              className="img-fluid"
                            />
                          )}
                        </div>
                      </div> */}
                      <div className="siptable-view">
                        <table className="table">
                          <thead>
                            <tr className="text-center">
                              <th>S.No</th>
                              <th scope="col">Date</th>
                              <th scope="col">Product Name</th>
                              <th scope="col">Quantity</th>
                              <th scope="col">Order id</th>

                            </tr>
                          </thead>

                          <tbody>
                            {isloading ? (
                              <tr>
                                <td colSpan="5" className="text-center py-4">
                                  <div className="tableload tableload2 commision-load text-center mt-5">
                                    <div
                                      className="spinner-border text-primary text-center"
                                      role="status"
                                    ></div>
                                  </div>
                                </td>
                              </tr>
                            ) : Agentorderlist?.length === 0 ? (
                              <tr>
                                <td colSpan="5" className="text-center py-4">
                                  No orders available.
                                </td>
                              </tr>
                            ) : (
                              (rowsToShow === 0
                                ? Agentorderlist
                                : Agentorderlist.slice(0, rowsToShow)
                              ).map((r, i) => (
                                <tr className="text-center" key={i}>
                                  {/* <td>{r.order_code}</td> */}
                                  <td>{i + 1}</td>
                                  <td>
                                    {new Date(r.created_at).toLocaleString('en-IN', {
                                      day: '2-digit',
                                      month: 'short',
                                      year: 'numeric',
                                      hour: '2-digit',
                                      minute: '2-digit',
                                      hour12: true
                                    })}
                                  </td>
                                  <td>
                                    {r?.product?.name ? r?.product?.name : "-"}
                                  </td>
                                  {/* <td>
                                    {" "}
                                    ₹{" "}
                                    {r?.product?.price
                                      ? r?.product?.price
                                      : " "}
                                  </td> */}

                                  <td>
                                    {r?.qty ? r?.qty : "0"}
                                  </td>
                                  <td>{r.order_code}</td>
                                  {/* <td>
                                    {" "}
                                    {r?.order?.grand_total != null
                                      ? `₹ ${Number(r?.order?.grand_total).toLocaleString('en-IN', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}`
                                      : "-"
                                    }
                                  </td> */}
                                  {/* <td
                                    style={{
                                      color:
                                        r?.order.payment_status === "pending"
                                          ? "blue"
                                          : r.status === "purchased"
                                            ? "black"
                                            : "green",
                                      // r?.order.payment_status === "pending"
                                      //   ? "blue"
                                      //   : r.status === "paid"
                                      //     ? "green"
                                      //     : "black",

                                    }}
                                  >
                                    {r?.order.payment_status}
                                  </td> */}

                                  {/* Hidden Modal Section */}
                                  <td colSpan={5} className="p-0 border-0">
                                    <section className="odersection">
                                      <button
                                        type="button"
                                        className="btn btn-primary d-none"
                                        data-bs-toggle="modal"
                                        data-bs-target="#paymentbox"
                                        id="payment-pup"
                                      >
                                        Launch demo modal
                                      </button>

                                      <div
                                        className="modal fade"
                                        id="paymentbox"
                                        tabIndex="-1"
                                        role="dialog"
                                        aria-labelledby="exampleModalCenterTitle"
                                        aria-hidden="true"
                                      >
                                        <div className="modal-dialog modal-dialog-centered">
                                          <div className="modal-content">
                                            <div className="modal-header d-flex justify-content-between">
                                              <div className="colhome2">
                                                <b>
                                                  Order Id :{" "}
                                                  {selectedOrder?.orderid}
                                                </b>
                                              </div>
                                              <div className="d-flex">
                                                <div
                                                  className="buttondesign2 marginleft align-items-center"
                                                  style={{ cursor: "pointer" }}
                                                  onClick={() =>
                                                    setShowCancelModal(true)
                                                  }
                                                >
                                                  <b>Order Cancel</b>
                                                </div>
                                                <button
                                                  type="button"
                                                  className="btn-close"
                                                  data-bs-dismiss="modal"
                                                  aria-label="Close"
                                                ></button>
                                              </div>
                                            </div>
                                            <div className="modal-body">
                                              {selectedOrder && (
                                                <div className="d-flex gap-3">
                                                  <img
                                                    src={selectedOrder?.image}
                                                    alt={selectedOrder?.name}
                                                    className="img-fluid forthis"
                                                  />
                                                  <div>
                                                    <h6 className="fw-bold">
                                                      {selectedOrder?.name}
                                                    </h6>
                                                    <p className="text-muted">
                                                      {selectedOrder?.price}
                                                    </p>
                                                    <p
                                                      className="text-capitalize"
                                                      style={{
                                                        color:
                                                          selectedOrder?.status ===
                                                            "pending"
                                                            ? "orange"
                                                            : selectedOrder.status ===
                                                              "paid"
                                                              ? "green"
                                                              : "black",
                                                      }}
                                                    >
                                                      Status:{" "}
                                                      {selectedOrder?.status}
                                                    </p>
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </section>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {type === "Products" && Number(detail_info?.company) === 1 && (
                <div className="col-xl-9 col-lg-8">
                  <div className="siptrans-content">
                    <div className="siptrans-head pb-3">
                      <h4>Products List</h4>
                    </div>
                    <div
                      className="siptrans-table border pt-2 "
                      style={{ overflow: "auto" }}
                    >
                      {/* <div className="sipshow-search d-flex align-items-center  justify-content-between gap-sm-0 gap-3">
                        <div className="sipshow d-flex align-items-center gap-sm-3 gap-2 mb-3">
                          <h4 className="m-0">Show</h4>
                          <select
                            className="form-select"
                            id="inputGroupSelectshow"
                            value={rowsToShow}
                            onChange={handleRowsToShowChange}
                            style={{ width: "80px" }}
                          >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value={0}>All</option>
                          </select>
                        </div>
                        <div className="sip-search position-relative">
                          <input
                            type="text"
                            className="form-control"
                            id="inputemail"
                            placeholder="Search"
                            value={searchText}
                            onChange={handleInputChange}
                          />
                          {searchText.trim() === "" && (
                            <img
                              src="\assets\iocns\Search.png"
                              className="img-fluid"
                            />
                          )}
                        </div>
                      </div> */}
                      <div className="siptable-view">
                        <table className="table">
                          <thead>
                            <tr className="text-center">
                              <th>S.No</th>
                              <th scope="col">Image</th>
                              <th scope="col">Product Name</th>
                              <th scope="col">Category</th>
                              <th scope="col">Quantity</th>
                              {/* <th scope="col">Price</th> */}
                            </tr>
                          </thead>

                          <tbody>
                            {isloading ? (
                              <tr>
                                <td colSpan="4" className="text-center py-4">
                                  <div className="tableload tableload2 commision-load text-center mt-5">
                                    <div
                                      className="spinner-border text-primary text-center"
                                      role="status"
                                    ></div>
                                  </div>
                                </td>
                              </tr>
                            ) : productListData?.length === 0 ? (
                              <tr>
                                <td colSpan="4" className="text-center py-4">
                                  No products available.
                                </td>
                              </tr>
                            ) : (
                              (rowsToShow === 0
                                ? productListData
                                : productListData.slice(0, rowsToShow)
                              ).map((r, i) => (
                                <tr className="text-center" key={i}>
                                  <td>{i + 1}</td>
                                  <td>
                                    {r?.image ? (
                                      <img
                                        src={r?.image}
                                        width={100}
                                        height={30}
                                        className=""
                                        alt="greenheap"
                                      />
                                    ) : (
                                      <img
                                        src="/assets/images/green.png"
                                        width={100}
                                        className=""
                                        alt="greenheap"
                                      />
                                    )}
                                  </td>
                                  <td
                                    style={{ cursor: "pointer", color: "#cc995e", fontWeight: "600" }}
                                    onClick={() => handleOpenStockModal(r)}
                                  >
                                    {r?.name ? r?.name : "-"}
                                  </td>
                                  <td>{r?.category?.name ||  "-"}</td>
                                  <td>{r?.quantity ?? 0}</td>
                                  {/* <td> ₹ {r?.price ? r?.price : " "}</td> */}

                                  {/* Hidden Modal Section */}
                                  <section className="odersection">
                                    <button
                                      type="button"
                                      className="btn btn-primary d-none"
                                      data-bs-toggle="modal"
                                      data-bs-target="#paymentbox"
                                      id="payment-pup"
                                    >
                                      Launch demo modal
                                    </button>

                                    <div
                                      className="modal fade"
                                      id="paymentbox"
                                      tabIndex="-1"
                                      role="dialog"
                                      aria-labelledby="exampleModalCenterTitle"
                                      aria-hidden="true"
                                    >
                                      <div className="modal-dialog modal-dialog-centered">
                                        <div className="modal-content">
                                          <div className="modal-header d-flex justify-content-between">
                                            <div className="colhome2">
                                              <b>
                                                Order Id :{" "}
                                                {selectedOrder?.orderid}
                                              </b>
                                            </div>
                                            <div className="d-flex">
                                              <div
                                                className="buttondesign2 marginleft align-items-center"
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  setShowCancelModal(true)
                                                }
                                              >
                                                <b>Order Cancel</b>
                                              </div>
                                              <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                              ></button>
                                            </div>
                                          </div>
                                          <div className="modal-body">
                                            {selectedOrder && (
                                              <div className="d-flex gap-3">
                                                <img
                                                  src={selectedOrder?.image}
                                                  alt={selectedOrder?.name}
                                                  className="img-fluid forthis"
                                                />
                                                <div>
                                                  <h6 className="fw-bold">
                                                    {selectedOrder?.name}
                                                  </h6>

                                                  <p className="text-muted">
                                                    Quantity: {selectedOrder?.quantity}
                                                  </p>
                                                  <p className="text-muted">
                                                    {selectedOrder?.price}
                                                  </p>
                                                  <p
                                                    className="text-capitalize"
                                                    style={{
                                                      color:
                                                        selectedOrder?.status ===
                                                          "pending"
                                                          ? "orange"
                                                          : selectedOrder.status ===
                                                            "purchased"
                                                            ? "green"
                                                            : "red",
                                                    }}
                                                  >
                                                    Status:{" "}
                                                    {selectedOrder?.status}
                                                  </p>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </section>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Product Stock Modal */}
              {showStockModal && (
                <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }} tabIndex="-1">
                  <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Stock Details - {selectedProductForStock?.name}</h5>
                        <button type="button" className="btn-close" onClick={() => setShowStockModal(false)}></button>
                      </div>
                      <div className="modal-body">
                        {stockLoading ? (
                          <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status"></div>
                          </div>
                        ) : (
                          <>
                            {/* Summary Section */}
                            <div className="row mb-4">
                              <div className="col-md-4">
                                <div className="card text-center border-0 shadow-sm" style={{ backgroundColor: "#f8f9fa", borderRadius: "10px" }}>
                                  <div className="card-body">
                                    <h6 className="text-muted mb-1">Total In</h6>
                                    <h4 className="fw-bold mb-0" style={{ color: "green" }}>{stockData?.summary?.total_in || 0}</h4>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="card text-center border-0 shadow-sm" style={{ backgroundColor: "#f8f9fa", borderRadius: "10px" }}>
                                  <div className="card-body">
                                    <h6 className="text-muted mb-1">Total Out</h6>
                                    <h4 className="fw-bold mb-0" style={{ color: "red" }}>{stockData?.summary?.total_out || 0}</h4>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="card text-center border-0 shadow-sm" style={{ backgroundColor: "#f8f9fa", borderRadius: "10px" }}>
                                  <div className="card-body">
                                    <h6 className="text-muted mb-1">Available Stock</h6>
                                    <h4 className="fw-bold mb-0" style={{ color: "#cc995e" }}>{stockData?.summary?.available_stock || 0}</h4>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Data Table */}
                            <div className="table-responsive">
                              <table className="table table-bordered table-hover">
                                <thead className="table-light">
                                  <tr className="text-center">
                                    <th>S.No</th>
                                    <th>Date</th>
                                    <th>Quantity</th>
                                    <th>Type</th>
                                    {/* <th>Remark</th> */}
                                    <th>Invoice</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {stockData?.data && stockData.data.length > 0 ? (
                                    stockData.data.map((item, index) => (
                                      <tr key={index} className="text-center">
                                        <td>{(stockData.pagination.current_page - 1) * stockData.pagination.per_page + index + 1}</td>
                                        <td>
                                          {new Date(item.created_at).toLocaleString('en-IN', {
                                            day: '2-digit',
                                            month: 'short',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            hour12: true
                                          })}
                                        </td>
                                        <td>{item.quantity}</td>
                                        <td>
                                          <span className={`badge ${item.type === 'in' ? 'bg-success' : 'bg-danger'}`}>
                                            {item.type?.toUpperCase()}
                                          </span>
                                        </td>
                                        {/* <td>{item.remark || "-"}</td> */}
                                        <td>
                                          {item.invoice ? (
                                            <a href={item.invoice} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary">
                                              <i className="fa fa-download me-1"></i> {item.invoice_id || item.id}
                                            </a>
                                          ) : "-"}
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="6" className="text-center py-3">No stock records found.</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>

                            {/* Pagination */}
                            {stockData?.pagination?.last_page > 1 && (
                              <nav className="mt-3">
                                <ul className="pagination justify-content-center">
                                  <li className={`page-item ${stockData.pagination.current_page === 1 ? 'disabled' : ''}`}>
                                    <button
                                      className="page-link"
                                      onClick={() => fetchProductStock(selectedProductForStock.id, stockData.pagination.current_page - 1)}
                                    >
                                      Previous
                                    </button>
                                  </li>
                                  {[...Array(stockData.pagination.last_page)].map((_, i) => (
                                    <li key={i} className={`page-item ${stockData.pagination.current_page === i + 1 ? 'active' : ''}`}>
                                      <button
                                        className="page-link"
                                        onClick={() => fetchProductStock(selectedProductForStock.id, i + 1)}
                                      >
                                        {i + 1}
                                      </button>
                                    </li>
                                  ))}
                                  <li className={`page-item ${stockData.pagination.current_page === stockData.pagination.last_page ? 'disabled' : ''}`}>
                                    <button
                                      className="page-link"
                                      onClick={() => fetchProductStock(selectedProductForStock.id, stockData.pagination.current_page + 1)}
                                    >
                                      Next
                                    </button>
                                  </li>
                                </ul>
                              </nav>
                            )}
                          </>
                        )}
                      </div>
                      <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={() => setShowStockModal(false)}>Close</button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Myorder;
